import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

/**
 * Returns { isMobile, ready }.
 * ready is false on first render and becomes true after the first effect runs,
 * so we can defer rendering the table until we know the breakpoint and avoid
 * mounting the wrong view (desktop then mobile) which causes duplicate API calls.
 */
export function useBreakpointReady(): { isMobile: boolean; ready: boolean } {
  const [ready, setReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    setIsMobile(media.matches);
    setReady(true);
    const listener = () => setIsMobile(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return { isMobile, ready };
}
